<div class="dialog-content-wrapper p-0">
    <mat-toolbar class="mat-accent m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <div class="tool">
                <span class="title dialog-title">{{"Enter Vots" | translate}}</span>
                <button mat-icon-button class="close" aria-label="Close dialog" mat-dialog-close>
                    <mat-icon>close</mat-icon>
                </button>
            </div>

        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 pb-0 m-0" fxLayout="column" fusePerfectScrollbar>
        <mat-form-field appearance="outline">
            <mat-label>{{"Self" | translate}}</mat-label>
            <input #selfVotes matInput [(ngModel)]="selfvots" name="selfvots">
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>{{"Opp 1" | translate}}</mat-label>
            <input matInput [(ngModel)]="opp_1" name="opp_1">
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>{{"Opp 2" | translate}}</mat-label>
            <input matInput [(ngModel)]="opp_2" name="opp_2">
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>{{"Total Votes" | translate}}</mat-label>
            <input matInput [(ngModel)]="total" name="total">
        </mat-form-field>
        <div class="btn">
            <button mat-raised-button mat-dialog-close class="mr-4 blue">{{"To Delete" | translate}}</button>
            <button mat-raised-button class="green-600" (click)="edit()">{{"To Edit" | translate}}</button>
        </div>
    </div>
</div>